import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import ReactGA from 'react-ga';

let root = createRoot(document.getElementById('root'));
root.render(<App />);

